


































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { InfractionRuleService } from '../../service/InfractionRuleService';
import { InfractionRuleType } from '../../models/infractions/InfractionRuleType';
import { AgentService } from '../../service/AgentService';
import { ClientService } from '../../service/ClientService';
import { CountryService } from '../../service/CountryService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup
} from 'devextreme-vue/data-grid';
import { DxItem, DxGroupItem, DxButtonItem } from 'devextreme-vue/form';
import { DxSelectBox, DxButton, DxTextBox } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import {
  InfractionRuleDateColumns,
  InfractionRuleTextColumns
} from '../../models/infractions/InfractionRuleColumns';
import { InfractionRuleTypeDto } from '../../models/infractions/InfractionRuleTypeDto';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { SelectOption } from '../../models/SelectOption';
import { Watch } from 'vue-property-decorator';
import { AgentDto } from '../../models/agent/AgentDto';

@Component({
  components: {
    DxSelectBox,
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxGroupItem,
    DxButtonItem,
    DxLookup,
    DxPopup,
    DxButton,
    DxTextBox
  }
})
export default class InfractionRulesGrid extends Vue {
  clients: Array<SelectOption> = [];
  agents: Array<SelectOption> = [];
  filteredAgents: Array<SelectOption> = [];
  selectedClient: Guid = '';
  countries: Array<SelectOption> = [];
  operators: Array<SelectOption> = [
    {text: "<", value: "<"},
    {text: ">", value: ">"},
    {text: "=", value: "="},
    {text: "!=", value: "!="}
  ];
  comparisonTypes: Array<SelectOption> = [
    {text: "Column Has Text", value: "ColumnHasText"},
    // {text: "N-grams", value: "Ngrams"},
    {text: "Exact Match", value: "ExactMatch"}
  ];
  private get allOperators() : Array<SelectOption> {
    return this.operators.concat(this.comparisonTypes);
  }

  availableInfractionRuleDateColumns: Array<SelectOption> = InfractionRuleDateColumns;
  availableInfractionRuleTextColumns: Array<SelectOption> = InfractionRuleTextColumns; 
  private get allColumns(): Array<SelectOption> {
    return this.availableInfractionRuleDateColumns.concat(this.availableInfractionRuleTextColumns);
  }

  infractionRuleTypes: Array<{ text: string, value: number }> = [];
  infractionTypes: Array<{ text: string , value?: Guid }> = [];

  infractionRuleService: InfractionRuleService;
  infractionRulesCustomStoreOptions: DevExpress.data.CustomStoreOptions;

  compareDatesSelected: boolean = false;
  textSearchSelected: boolean = false;
  columnTextLengthSelected: boolean = false;

  selectedRuleType: number = -1;
  dataGrid: any;

  agentService: AgentService = new AgentService();
  clientService: ClientService = new ClientService();

  constructor() { 
    super();

    this.infractionRuleService = new InfractionRuleService(
      '/api/InfractionRules'
    );

    this.infractionRulesCustomStoreOptions = {
      key: 'InfractionRuleId',
      load: loadOptions => this.infractionRuleService.search(loadOptions),
      insert: (values) => {
        return this.infractionRuleService.create(values)
          .catch((e: any) => {
            if(e && e.Message) {
              throw e.Message;
            }
            throw "An error occurred.";
          });
      },
      update: (key, values) => {
        // TODO: We might want to add more general handling in the client class
        return this.infractionRuleService.edit(key, values)
          .catch((e: any) => {
            if(e && e.Message) {
              throw e.Message;
            }
            throw "An error occurred.";
          });
      },
      remove: key => this.infractionRuleService.delete(key)
    };
  }

  created() {
    this.loadData();
  }
  get clientOption(): any {
      return {
        "placeholder" : "Select a client",
        "dataSource" : this.clients,
        "displayExpr": "text",
        "valueExpr": "value",
        "searchEnabled": true,
        "onSelectionChanged": this.onClientSelectionChanged,
        "popupHeight": '350px'
      };
    }
  get agentOption(): any {
      return {
        "placeholder" : "Select an agent",
        "dataSource" : this.agents,
        "displayExpr": "text",
        "valueExpr": "value",
        "popupHeight": "350px",
        "searchEnabled": true,
        "onOpened" : this.OnOpened
      };
    }
  
  async OnOpened(e: any) {
    e.component.option("dataSource", []);
    e.component.instance().beginUpdate();
    var result = await this.agentDataSource();
    
    e.component.option("dataSource", result);

    e.component.instance().endUpdate();
  }

  selectedClientId: Guid = "";
  private agentDataSource() : Promise<any> {
    return this.agentService.getAll(this.selectedClientId)
         .then((success : AgentDto[]) => {
          let result = success.map((c: AgentDto) => {
              return { text: c.AgentName, value: c.AgentId };
            });
          
          result.unshift({text:"ALL", value: ""});

          return result;
        })
        .catch(err => []);
  }

  setSelectedClientId(val: any): void {
    this.selectedClientId = val;
  }

  onClientSelectionChanged(e: any) {
    this.setSelectedClientId(e.selectedItem? e.selectedItem.value : '');
  }

  async loadData() {    
    this.clients = await this.clientService.getAll()
      .then((success: any) => {
        let result = success.map((c: any) => {
          return { text: c.ClientName, value: c.ClientId };
        })

        result.unshift({text:"ALL", value: ""});

        return result;
      })
      .catch(err=> []);

    this.agents = await this.agentDataSource();

    let countryService = new CountryService();
    this.countries = await countryService.getAll()
    .then((success : any) => {
      let result = success.map((c: any) => {
        return { text: c.CountryCode, value: c.CountryId };
      });

      result.unshift({text:"ALL", value: ""});

      return result;
    })
    .catch(err => []);

    this.infractionRuleTypes = await this.infractionRuleService.getRuleTypes()
    .then((success:any) => {
      let result = success.map((t:any) => { return { text: t.Name, value: t.InfractionRuleTypeId } });

      return result;
    })
    .catch(err => []);

    this.infractionTypes = await this.infractionRuleService.getTypes()
      .then((success : any) => {
        let result = success.map((t:any) => { return { text: t.Name, value: t.InfractionTypeId } });

        return result;
      })
      .catch(err => []);
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  popupShowing(e: any) {
    // Couldn't find a configuration option for this, so changing the style of Save and Cancel when loading the dialog.
    var toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems',toolbarItems);
  }

  initNewRow(e: any) {
    e.data = {
      ClientId: "",
      AgentId: "",
      CountryId: null
    };
    this.selectedRuleType = -1;
    // this.filteredAgents = this.agents;
  }

  rowUpdating(e: any) {
    // Add back any data not edited
    e.newData = Object.assign({}, e.oldData, e.newData);      
  }

  rowEditing(e: any) {
    this.selectedRuleType = e.data.InfractionRuleTypeId;
    this.setSelectedRuleType();
  }
 

  saveEditData(): void {
    if (this.dataGrid) {
      this.dataGrid.saveEditData();
    }
  }

  selectedRuleTypeChanged(e: any): void {
    this.selectedRuleType = e.itemData.value;
    this.setSelectedRuleType();
    e.event.stopPropagation();
  }
  
  async onSelectionChanged(e: any) {
    let newClientId = e.value;
    if(newClientId != "") {
        let agents =  await this.clientService.getAgentByClientId(newClientId);
        this.filteredAgents = agents.map(a => {
         return { text: a.AgentName, value: a.AgentId };
        });
        this.filteredAgents.unshift({text:"ALL", value: ""});
    }
    else {
        // this.filteredAgents = this.agents;
    }
  }
   

  private setSelectedRuleType() {
    this.compareDatesSelected = false;
    this.textSearchSelected = false;
    this.columnTextLengthSelected = false;
    
    switch(this.selectedRuleType) {
      case InfractionRuleType.Compare_Dates: {
        this.compareDatesSelected = true;             
        break;
      }
      case InfractionRuleType.Text_Search_Match: {
        this.textSearchSelected = true;
        break;
      }
      case InfractionRuleType.Column_Text_Length: {
        this.columnTextLengthSelected = true;
        break;
      }
    }
  }

  customizeNullText(info: any) {
    return info.valueText === '' ? 'ALL' : info.valueText;
  }
}
